import { TTypeOfCodec } from "../../../shared/src/codecs/codec";
import { TFormCodec, form } from "../../../shared/src/codecs/types/form";
import { TRequiredCodec, required } from "../../../shared/src/codecs/types/required";
import { TUuidCodec, uuid } from "../../../shared/src/codecs/types/uuid";
import { TBooleanCodec, boolean } from "../../../shared/src/codecs/types/boolean";
import { EmptyObject, TEmptyObjectCodec } from "../EmptyObject";
import { TArrayCodec, array } from "../../../shared/src/codecs/types/array";
import { TAnyStringCodec, string } from "../../../shared/src/codecs/types/string";
import { TIntegerCodec, integer } from "../../../shared/src/codecs/types/integer";

// Form for toggling a user's away status
export const ToggleAwayStatusForm: TFormCodec<TRequiredCodec<{
    user_id: TUuidCodec,
    is_away: TBooleanCodec,
}>, TRequiredCodec<{
    unassigned_email_count: TIntegerCodec,
}>> = form(
    required({
        user_id: uuid(),
        is_away: boolean(),
    }),
    required({
        unassigned_email_count: integer(),
    }),
);
export type TToggleAwayStatusFormCodec = typeof ToggleAwayStatusForm;
export type TToggleAwayStatusForm = TTypeOfCodec<TToggleAwayStatusFormCodec>;

// Codec for a staff member in the staff inboxes list
export const StaffInboxMember = required({
    id: uuid(),
    first_name: string(),
    last_name: string(),
    is_away: boolean(),
    unresolved_email_count: integer(),
});
export type TStaffInboxMemberCodec = typeof StaffInboxMember;
export type TStaffInboxMember = TTypeOfCodec<TStaffInboxMemberCodec>;

// Form for fetching the staff inboxes list
export const GetStaffInboxesForm: TFormCodec<TEmptyObjectCodec, TRequiredCodec<{
    staff: TArrayCodec<TStaffInboxMemberCodec>,
}>> = form(
    EmptyObject,
    required({
        staff: array(StaffInboxMember),
    }),
);
export type TGetStaffInboxesFormCodec = typeof GetStaffInboxesForm;
export type TGetStaffInboxesForm = TTypeOfCodec<TGetStaffInboxesFormCodec>;
